import { Token } from "./auth.model";

export class AuthAction
{
    static readonly type = '[Auth Page] Auth';
    constructor(public authSettings: Token) { }
}
